import { Row, } from "antd";
import { ReactElement, useEffect, useState } from "react";
import cardBg1 from "../images/cards/1.png";
import cardBg2 from "../images/cards/2.png";
import cardBg3 from "../images/cards/3.png";
import cardBg4 from "../images/cards/4.png";
import cardBg5 from "../images/cards/5.png";
import cardBg6 from "../images/cards/6.png";
import cardBg8 from "../images/cards/Ticket-Recreation.png";
import { observer } from "mobx-react-lite";
import AllAccessCard from "../components/Card/AllAccessCard";
import { useStore } from "../root-store-context";
import cardBg7 from "../images/cards/tenant.png";

const MainPage = observer((): ReactElement => {
  const { applicationStore, apiStore } = useStore();
  const [balance, setBalance] = useState<number>(0);
  const [complianceOpenItems, setComplianceOpenItems] = useState<number>(0);
  const [archOpenRequests, setArchOpenRequests] = useState<number>(0);
  const [allAccessCardItems, setAllAccessCardItems] = useState<string[]>([]);

  useEffect(() => {
    const cardItems: string[] = [];
    applicationStore.routingList.forEach((route) => {
      if (route.children) {
        route.children.forEach((children) => {
          if (children.path) {
            if (
              route.path === "/" &&
              children.path.length > 0 &&
              children.path[0] === "/"
            ) {
              cardItems.push(`${children.path}`);
            } else {
              cardItems.push(`${route.path}${children.path}`);
            }
          } else {
            cardItems.push(`${route.path}`);
          }
        });
      } else {
        if (route.path) cardItems.push(`${route.path}`);
      }
    });
    setAllAccessCardItems(cardItems);
  }, [applicationStore.routingList]);

  useEffect(() => {
    apiStore.CommonApiClient.getLandingPageInfo()
      .then((result) => {
        if (result.status === 200) {
          setBalance(result.data.item1);
          setComplianceOpenItems(result.data.item2);
          setArchOpenRequests(result.data.item3);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const features = applicationStore.AllFeaturesForCommunityObject;

  const cards = [
    {
      key: "payment",
      title: "Make a Payment",
      backgroundString: cardBg1,
      link: "/AccountInfo/PayAndViewBalance",
      isActive:
        (features.PayandViewBalance?.isActive &&
          allAccessCardItems.includes("/AccountInfo/PayAndViewBalance")) ||
        false,
      headTitle: `Amount Due: $${Number(balance).toFixed(2)}`,
    },
    {
      key: "resident-directory",
      title: "Resident Directory",
      backgroundString: cardBg2,
      link: "/ResidentDirectory",
      isActive:
        (features.ResidentDirectory?.isActive &&
          allAccessCardItems.includes("/ResidentDirectory")) ||
        false,
      headTitle: "",
    },
    {
      key: "compliance",
      title: "Compliance Issues",
      backgroundString: cardBg3,
      link: "/AccountInfo/Compliance",
      isActive:
        (features.Compliance?.isActive &&
          allAccessCardItems.includes("/AccountInfo/Compliance")) ||
        false,
      headTitle: `Open Items: ${complianceOpenItems}`,
    },
    {
      key: "architectural-requests",
      title: "Architectural Requests",
      backgroundString: cardBg4,
      link: "/AccountInfo/ArchitecturalRequests",
      isActive:
        (features.ArchitecturalRequests?.isActive &&
          allAccessCardItems.includes("/AccountInfo/ArchitecturalRequests")) ||
        false,
      headTitle: `Requests: ${archOpenRequests}`,
    },
    {
      key: "maintenance-request",
      title: "Maintenance Request",
      backgroundString: cardBg5,
      link: "/Forms/MaintenanceRequest",
      isActive:
        features.MaintenanceRequestSP?.isActive ||
        (features.MaintenanceRequestemail?.isActive &&
          allAccessCardItems.includes("/Forms/MaintenanceRequest")) ||
        false,
      headTitle: "",
    },
    {
      key: "tenant-registration",
      title: "Tenant Registration",
      backgroundString: cardBg7,
      link: "/Forms/TenantRegistrations",
      isActive: true, // features.TenantRegistration?.isActive || false
      headTitle: "",
    },
    {
      key: "guest-passes",
      title: "Guest Passes",
      backgroundString: cardBg6,
      link: "/Association/GuestPasses",
      isActive:
        (features.GuestPasses?.isActive &&
          allAccessCardItems.includes("/Association/GuestPasses")) ||
        false,
      headTitle: "",
    },
    {
      key: "guest-passes-abdi",
      title: "Guest Passes",
      backgroundString: cardBg6,
      link: "/Association/GuestPasses",
      isActive:
        (features.ABDIGatePasses?.isActive &&
          allAccessCardItems.includes("/Association/GuestPasses")) ||
        false,
      headTitle: "",
    },
    {
      key: "guest-passes-abdi",
      title: "Recreation & Tickets",
      backgroundString: cardBg8,
      link: "/Association/RecreationAndTickets",
      isActive:
        (features.TicketsandRecreation?.isActive &&
          allAccessCardItems.includes("/Association/RecreationAndTickets")) ||
        false,
      headTitle: "",
    },
  ];

  return (
    <>
      <h1>AAM All Access</h1>
      <Row gutter={[16, 16]} >
        {cards.map((card) => (
          <AllAccessCard
            key={card.key}
            title={card.title}
            backgroundString={card.backgroundString}
            link={card.link}
            isActive={card.isActive}
            headTitle={card.headTitle}
          />
        ))}
      </Row>
    </>
  );
});

export default MainPage;
